import Svg from 'components/utilities/svg'

const HashIcon = ({ ...props }) => (
  <Svg viewBox="0 0 24 24" {...props}>
    <title>Hash Icon</title>
    <path d="m5.275 20.575 1-4h-3.5l.775-3.15h3.5l.725-2.85h-4l.775-3.15h4l1-4h3.175l-1 4h2.825l1-4h3.175l-1 4h3.5l-.775 3.15h-3.5l-.725 2.85h4l-.775 3.15h-4l-1 4h-3.175l1-4H9.45l-1 4Zm4.95-7.15h2.825l.725-2.85H10.95Z" />
  </Svg>
)

HashIcon.displayName = 'Hash'

export default HashIcon
